import React from "react";
import { Practices } from "../../constant";
import {Col, Row} from 'react-bootstrap'

const Experience = ({from, title, post, task}) => {
    return <div className="cv__experience">
        <Row>
            <Col md={3}>
                <span className='text-secondary'>{from}</span>
            </Col>
            <Col>
                <h5 className='fw-bold'>{title}</h5>
                {post && <p className='text-secondary'>{post}</p>}
                Tâches Réalisées:
                {task && <ul>
                    {task.map((v,k) => {
                        return <li  key={k}>{v}</li>
                    })}
                </ul>}
            </Col>
        </Row>
    </div>
}

const Experiences = () => {
    return <div className="cv__experiences">
        <h4 className="mt-3 mb-3">Expérience professionnelle</h4>
        {
            Practices.map((v, k) => {
                return <Experience key={k} {...v} />
            })
        }
    </div>
}

export default Experiences